import { Box, Divider, Typography } from '@mui/material';
import { FlexContainer } from '@act/storybook';
import ResetTrainingCharacters from './reset-training-characters';
import TrainingProviderStatus from './training-provider-status';

const TrainingAdminPage = () => {
  return (
    <FlexContainer direction="column" gap={3}>
      <Box>
        <Typography variant="headlineLarge">
          Secret Training Admin Page
        </Typography>
        <Typography variant="bodyMedium" component="p">
          Be careful what you click. Only users with an admin role will have any
          effect on things when they click.
        </Typography>
      </Box>
      <Divider />
      <ResetTrainingCharacters />
      <Divider />
      <TrainingProviderStatus />
    </FlexContainer>
  );
};

export default TrainingAdminPage;
